import styled from 'styled-components'

export const DownloadButton = styled.button`
  width: 12rem;
  height: 3rem;
  margin: 1rem 0;
  cursor: pointer;
  color: white;
  font-weight: 600;
  border-radius: 8px;
  border: 0;

  background-color: ${(props) => props.theme.colors.confirm};
  &:hover {
    background-color: ${(props) => props.theme.colors.confirmHover};
  }
`
